import { Link } from 'react-router-dom';

const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '只做归类，不下结论',
    desc: '我们把同类话题收进一个专题，保留不同说法之间的差异，不替读者判定对错。',
  },
  {
    icon: 'ri-links-line',
    title: '每条都标清出处',
    desc: '来自第三方口径的数据会标注来源，方便你回到原始语境自己判断。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新不封闭',
    desc: '热门专题会继续补充条目，已经结束的盘点则明确标记为已完结。',
  },
];

export default function Principles() {
  return (
    <section id="principles" className="px-4 md:px-10 py-16 md:py-20" aria-label="内容原则">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="text-xs tracking-[0.3em] text-primary-600 font-medium">OUR PRINCIPLES</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
            我们怎么整理，
            <br />
            决定了你能多快看完
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            专题合集的全部价值在于省时间。所以从选题到成稿，我们都围绕同一件事：
            让读者在最短的路径里拿到最完整的同类信息。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {principles.map((item) => (
              <div key={item.title} className="rounded-lg bg-background-100 border border-background-200 p-5">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center text-xl">
                  <i className={item.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>

          <figure className="mt-5 rounded-lg border-l-4 border-primary-500 bg-background-100 px-6 py-6">
            <blockquote className="font-heading text-base md:text-lg text-foreground-800 leading-relaxed">
              “以前找同类话题得一个个搜，现在直接进专题合集，一次就看完，还能顺手看看榜单排在前面的有哪些。”
            </blockquote>
            <figcaption className="mt-3 text-xs text-foreground-500">
              —— 长期读者 林叙 · 使用黑料社网 14 个月
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}